module.exports = __webpack_public_path__ + "static/cobertura_analisis-e1149dedc3cbd94fc9a3d3dcdc7327f4.png";